import { render, staticRenderFns } from "./EventsComponent.vue?vue&type=template&id=6af1bfaf"
import script from "./EventsComponent.vue?vue&type=script&lang=js"
export * from "./EventsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports